import { combineReducers } from "redux";
import { reducer as checklist } from "./checklist/index";
import { reducer as todoDetails } from "./checklist/todo-details";
import { reducer as forms } from "./forms/index";
import { reducer as privacy } from "./privacy/index";
import { reducer as profile } from "./profile";
import { reducer as schedule } from "./schedule";
import { reducer as ui } from "./ui";

export default combineReducers({
    profile,
    checklist,
    ui,
    todoDetails,
    schedule,
    privacy,
    forms,
});
